<template>
  <ProSpaceBlock
    class="home__dashboard-card home__dashboard-period"
    height="50px"
    width="100%"
    margin="0"
    radius
    shadow
    color="card"
    style="display: flex; align-items: center; justify-content: space-between"
  >
    <ProSpaceHLayout :gap="10" class="dashboard-period__left">
      <div class="dashboard-period__btns">
        <ProSpaceIconButton
          icon="chevron-left"
          containerSize="25px"
          bordered
          :disabled="isPeriodsLoading || disabled"
          @click="switchPeriod('prev')"
        />
        <ProSpaceIconButton
          icon="chevron-right"
          containerSize="25px"
          bordered
          :disabled="isPeriodsLoading || disabled"
          @click="switchPeriod('next')"
        />
      </div>
      <span class="dashboard-period__name" @click="actionPeriod">
        {{ currentPeriod.name }}
      </span>
      <ProSpaceTag
        v-if="currentPeriod.status"
        :text="this.$t(`period_${currentPeriod.status}`)"
        :type="currentPeriod.status === 'opened' ? 'teal' : 'draft'"
      />
    </ProSpaceHLayout>
    <ProSpaceHLayout :gap="5" style="justify-content: flex-end">
      <ProSpaceFilterContainsChips
        v-model="modelFilter.area"
        :placeholder-value="$t('area')"
        :closeTxt="$t('closeTxt')"
        :applyTxt="$t('applyTxt')"
        :clearFilterTxt="$t('clearFilterTxt')"
        @apply="handlerApply"
      />
      <ProSpaceFilterSearchfield
        v-model="modelFilter.channelId"
        :service="channelService"
        getMethod="grid"
        optionValue="id"
        optionLabel="value"
        optionCode="code"
        :placeholder-value="$t('channel')"
        :txtTitleModal="$t('channelList')"
        :cancelTxt="$t('cancelTxt')"
        :closeTxt="$t('closeTxt')"
        :applyTxt="$t('applyTxt')"
        :clearFilterTxt="$t('clearTxt')"
        :defaultFilter="{ or: { disabled: false } }"
        @apply="handlerApply"
      />
      <ProSpaceFilterSearchfield
        v-if="checkAccess('dashboard-filters')"
        v-model="modelFilter.agencyId"
        :service="agencyService"
        getMethod="grid"
        optionValue="id"
        optionLabel="value"
        optionCode="code"
        :placeholder-value="$t('agency')"
        :txtTitleModal="$t('agencyList')"
        :cancelTxt="$t('cancelTxt')"
        :closeTxt="$t('closeTxt')"
        :applyTxt="$t('applyTxt')"
        :clearFilterTxt="$t('clearTxt')"
        :defaultFilter="{ or: { disabled: false } }"
        @apply="handlerApply"
      />
      <ProSpaceFilterSearchfield
        v-model="modelFilter.kAEId"
        :service="kAEService"
        getMethod="grid"
        optionValue="id"
        optionLabel="value"
        optionCode="code"
        :placeholder-value="$t('territory')"
        :txtTitleModal="$t('territory')"
        :cancelTxt="$t('cancelTxt')"
        :closeTxt="$t('closeTxt')"
        :applyTxt="$t('applyTxt')"
        :clearFilterTxt="$t('clearTxt')"
        :defaultFilter="{ or: { disabled: false } }"
        @apply="handlerApply"
      />
    </ProSpaceHLayout>
  </ProSpaceBlock>
</template>

<script>
import {
  ProSpaceBlock,
  ProSpaceHLayout,
  ProSpaceIconButton,
  ProSpaceFilterSearchfield,
  ProSpaceFilterContainsChips,
  ProSpaceFilterPanel,
  ProSpaceTag,
} from "@prospace/prospace-components-library";
import { KAEService } from "../../../services/KAEService";
import { AgencyService } from "../../../services/AgencyService";
import { ChannelService } from "../../../services/ChannelService";
import { mapGetters } from "vuex";
import Column from "primevue/column";
import { MarsPeriodService } from "../../../services/MarsPeriodService";
import accessMixin from "../../../../../../Frontends/Common/utils/elementAccess/accessMixin";

export default {
  mixins: [accessMixin],
  components: {
    ProSpaceBlock,
    ProSpaceHLayout,
    ProSpaceIconButton,
    ProSpaceFilterSearchfield,
    ProSpaceFilterContainsChips,
    ProSpaceFilterPanel,
    ProSpaceTag,
    Column,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      kAEService: new KAEService(),
      agencyService: new AgencyService(),
      channelService: new ChannelService(),
      modelFilter: { or: [] },
      marsPeriodService: new MarsPeriodService(),
      isPeriodsLoading: false,
    };
  },
  methods: {
    //open period selection window
    actionPeriod() {
      this.$store.commit("marsPeriodStoreArchived/SET_PERIODMODALSTATE", true);
    },
    handlerApply() {
      this.$emit("filter-apply", this.modelFilter);
    },
    async switchPeriod(action) {
      this.isPeriodsLoading = true;
      const periods = await this.getMorePeriods();
      this.isPeriodsLoading = false;
      let currentPeriodIndex = periods.indexOf(
        periods.find((period) => period.id === this.currentPeriod.id)
      );

      let updatedPeriod = null;

      if (action === "next") {
        //Если текущий период последний, то ничего не делать
        if (currentPeriodIndex + 1 === periods.length) return;
        updatedPeriod = periods[currentPeriodIndex + 1];
      } else {
        //Если текущий период первый, то ничего не делать
        if (currentPeriodIndex === 0) return;
        updatedPeriod = periods[currentPeriodIndex - 1];
      }
      this.$store.dispatch("marsPeriodStoreArchived/setMarsPeriod", updatedPeriod);
    },
    // getting periods by parts
    async getMorePeriods(skip = 0, result = []) {
      let skipRecords = skip ? skip : 0;
      let res = result;
      const topRecords = 100;

      if (res.length === 0) {
        res = await this.getPeriods();
      }
      if (res.length > 0 && res.length % 100 === 0) {
        skipRecords += topRecords;
        const part = await this.getPeriods(topRecords, skipRecords);
        res = [...res, ...part];
        await this.getMorePeriods(skipRecords, res);
      }

      return res;
    },
    async getPeriods(top = 100, skip = 0) {
      const params = `$filter=((((disabled eq false))))&$orderby=id asc&$top=${top}&$skip=${skip}`;
      let records = [];
      await this.marsPeriodService.grid(params).then((res) => {
        records = res.data.records;
      });

      return records;
    },
  },
  computed: {
    ...mapGetters({
      currentPeriod: "marsPeriodStoreArchived/getMarsPeriod",
      access: "securityRoleAccess/access",
    }),
  },
};
</script>
<style lang="scss">
.dashboard {
  &-period {
    &__btns {
      display: flex;
      .prospace-icon-button:last-child {
        margin-left: 5px;
      }
    }
    &__territory {
      min-width: 140px;
    }
    &__name {
      color: var(--prospace-text-main);
      font-size: 18px;
      font-weight: 700;
      border-bottom: 1px dashed var(--prospace-ui-icon-gray);
      cursor: pointer;
    }
  }
}
</style>
